import { ofType, combineEpics, type Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';

import Safescarf from '../../../api/safescarf';
import { handleError } from '../../errorHandler';

import {
  FETCH_MACHINE_ACCOUNTS_STARTED,
  fetchMachineAccountsFulfilled,
  createMachineAccountFulfilled,
  CREATE_MACHINE_ACCOUNT_STARTED,
} from './actions';

const fetchMachineAccountsEpic: Epic = action$ =>
  action$.pipe(
    ofType(FETCH_MACHINE_ACCOUNTS_STARTED),
    mergeMap(() =>
      from(Safescarf.fetchMachineAccounts()).pipe(
        mergeMap((response: { data: unknown }) => of(fetchMachineAccountsFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

const createMachineAccountEpic: Epic = action$ =>
  action$.pipe(
    ofType(CREATE_MACHINE_ACCOUNT_STARTED),
    mergeMap(() =>
      from(Safescarf.createMachineAccount()).pipe(
        mergeMap((response: { data: unknown }) => of(createMachineAccountFulfilled(response.data))),
        catchError(handleError)
      )
    )
  );

export default combineEpics(createMachineAccountEpic, fetchMachineAccountsEpic);
